<div class="ec-economics-container">
    <ng-container *ngIf="ecResource && isViewable; else unviewableResource">
        <div fxLayout="column">
            <div fxLayout="row">
                <div class="ec-menu" *ngIf="showNavbar">
                    <nav #navBar mat-tab-nav-bar app-nav-bar mat-align-tabs="start" class="menu-content">
                        <ng-container *ngIf="controlPanelUserType === ControlPanelUserType.SUPERVISOR">
                            <!-- Economics economics-aggregated view -->
                            <a mat-tab-link class="menu-item"
                               [routerLink]="['/c', 'ec', 'economics', 'aggregated']" [queryParams]="{}"
                               queryParamsHandling="merge"
                               routerLinkActive #rlaAggregated="routerLinkActive" [active]="rlaAggregated.isActive">
                                {{ 'Community total'|i18n }}
                            </a>
                            <!-- Economics economics-redistributed view-->
                            <a mat-tab-link class="menu-item"
                               [routerLink]="['/c', 'ec', 'economics', 'redistributed']" [queryParams]="{}"
                               queryParamsHandling="merge"
                               routerLinkActive #rlaRedistributed="routerLinkActive" [active]="rlaRedistributed.isActive">
                                {{ 'Redistribution for absorption'|i18n }}
                            </a>
                            <!-- Economics economics-subjects-summary view-->
                            <a mat-tab-link class="menu-item"
                               [routerLink]="['/c', 'ec', 'economics', 'subjects-summary']" [queryParams]="{}"
                               queryParamsHandling="merge"
                               routerLinkActive #sbjRecap="routerLinkActive" [active]="sbjRecap.isActive">
                                {{ 'Subjects recap'|i18n }}
                            </a>
                            <!-- Economics economics-totals-summary view-->
                            <a mat-tab-link class="menu-item"
                               [routerLink]="['/c', 'ec', 'economics', 'totals-summary']" [queryParams]="{}"
                               queryParamsHandling="merge"
                               routerLinkActive #rlaTotalsSummary="routerLinkActive" [active]="rlaTotalsSummary.isActive">
                                {{ 'Totals summary'|i18n }}
                            </a>
                        </ng-container>
                        <ng-container *ngIf="controlPanelUserType === ControlPanelUserType.THIRD_PARTY_PRODUCER">
                            <!-- Economics economics-totals-plants view-->
                            <a mat-tab-link class="menu-item"
                               [routerLink]="['/c', 'ec', 'economics', 'totals-plants']" [queryParams]="{}"
                               queryParamsHandling="merge"
                               routerLinkActive #rlaTotalsPlants="routerLinkActive" [active]="rlaTotalsPlants.isActive">
                                {{ 'Plants totals'|i18n }}
                            </a>
                            <!-- Economics economics-member-plants view-->
                            <a mat-tab-link class="menu-item"
                               [routerLink]="['/c', 'ec', 'economics', 'member-plants']" [queryParams]="{}"
                               queryParamsHandling="merge"
                               routerLinkActive #rlaMemberPlants="routerLinkActive" [active]="rlaMemberPlants.isActive">
                                {{ 'Detail for plant'|i18n }}
                            </a>
                        </ng-container>
                        <ng-container *ngIf="controlPanelUserType === ControlPanelUserType.ADVANCED">
                            <!-- Economics economics-totals-community view-->
                            <a mat-tab-link class="menu-item"
                               [routerLink]="['/c', 'ec', 'economics', 'totals-community']" [queryParams]="{}"
                               queryParamsHandling="merge"
                               routerLinkActive #rlaTotalsCommunity="routerLinkActive" [active]="rlaTotalsCommunity.isActive">
                                {{ 'Community totals'|i18n }}
                            </a>
                            <!-- Economics economics-member-pods view-->
                            <a mat-tab-link class="menu-item"
                               [routerLink]="['/c', 'ec', 'economics', 'member-pods']" [queryParams]="{}"
                               queryParamsHandling="merge"
                               routerLinkActive #rlaMemberPods="routerLinkActive" [active]="rlaMemberPods.isActive">
                                {{ 'Your POD and plants'|i18n }}
                            </a>
                        </ng-container>
                    </nav>
                </div>
            </div>
            <div class="ec-content">
                <router-outlet></router-outlet>
            </div>
        </div>
    </ng-container>
</div>

<ng-template #unviewableResource>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-16">
        {{ 'Insufficient permissions to view this resource'|i18n }}
    </div>
</ng-template>
